import React from "react"
import { Navigate, useLocation, Outlet } from "react-router-dom"
import useSession from "../hooks/useSession"

export default function PrivateRoute(props) {
    const { validRoles } = props

    const [isLoggedIn, isAuthorized] = useSession(validRoles)
    const location = useLocation()

    return (
        !isLoggedIn ? <Navigate to="/login" state={{redir: location.pathname}} replace /> :
            !isAuthorized ? <Navigate to={"/unauthorized"} replace /> :
                <Outlet />
    )
}